namespace C2S {

    export interface IReadOnly {
        get_readOnly(): boolean;
        set_readOnly(value: boolean): void;
    }

    @C2S.Decorators.registerInterface('C2S.IReadOnly')
    export class IReadOnly {
    }
}